import ApplicationSuccessPage from "./ApplicationSuccessPage"

export default ApplicationSuccessPage
